import React from 'react';

import { PeoPayrollProviderWallet } from 'src/components/peoPayrollProvider';

export const WalletAccountPagePeoPayrollProvider: React.FC = () => {
  return <PeoPayrollProviderWallet />;
};
